package com.yogaaicoach.pages.trainingprogram

// Mirrors composeApp's MainGoal enum (pages/trainingprogram/data/models/MainGoal.kt) — already
// Compose-free there (just an enum with a StringResource title), so no stripping needed beyond
// dropping the StringResource field itself, which the UI layer resolves via
// com.yogaaicoach.pages.dashboard.mainGoalDisplayName().
enum class MainGoal {
    PHYSICAL_STRENGTH,
    BALANCE_AND_COORDINATION,
    POSTURE_AND_ALIGNMENT,
    MOBILITY_AND_FLEXIBILITY
}
